import React from 'react'
import PageBanner from "app/components/ui/PageBanner"
import SiteGrid from "app/components/ui/SiteGrid"
import './styles/TeamPage.css'
import HelmetTitle from "app/meta/HelmetTitle"
import { doctorsArray } from "app/data/teamData"
import SquareGrid from "app/components/ui/SquareGrid"
import PageSection from "app/components/ui/PageSection"
import founderImg from "app/assets/images/founder-img.jpg"
import signature from "app/assets/images/signature.png"

export default function TeamPage() {

  const teamRender = doctorsArray?.map((doctor, index) => {
    return <div
      className="team-column"
      key={index}
    >
      <div className="img-container">
        <img src={doctor.img} alt={doctor.name} />
      </div>
      <div className="text-container">
        <h5>{doctor.name}</h5>
        <h6>{doctor.position}</h6>
        <p>{doctor.description}</p>
      </div>
      <div className="circle-1" />
      <div className="circle-2" />
      <SquareGrid color="#fff" />
    </div>
  })

  return (
    <div className="team-page">
      <HelmetTitle title="Our Team" />
      <PageBanner
        title="Team"
        subtitle="Innovative Collaborations: How Our Partners Help Us Deliver Exceptional Service"
      />
      <div className="page-content">
        <SiteGrid>
          <div className="titles">
            <h5>Our Team</h5>
            <h2>Get to know our<br />compassionate and dedicated staff</h2>
          </div>
          <div className="team-grid">
            {teamRender}
          </div>
        </SiteGrid>
        <PageSection
          subtitle="Our Founder"
          title="A Message From Dr. E. O. Ogunlana"
          text={<p>
            I am honored to share my message with you. When I first envisioned this 
            clinic, I knew that I wanted to create a place where patients could 
            receive exceptional care in a compassionate and welcoming environment. 
            Our team of healthcare professionals is committed to providing the highest 
            quality of care to our patients, and we are dedicated to helping each 
            individual achieve optimal health and wellness.
            <br /><br />
            I am proud of the work that we do at Aphrodite Healthcare, and I am grateful 
            for the opportunity to serve our community. I hope that you will take the time 
            to explore our website and learn more about our clinic and the services that 
            we offer. Thank you for considering Aphrodite Healthcare for your healthcare needs.
            <img src={signature} alt="Dr. E. O. Ogunlana" />
          </p>}
          img={founderImg}
        />
      </div>
    </div>
  )
}
